module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai601-5c2494e12e654224467ef25580540031.jpg";